var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 187.479,
    height: 33.143,
    viewBox: "0 0 187.479 33.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Haydon_Logotype_CMYK_White",
    transform: "translate(-75.8 -125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M76.441,159.248l-.641-.641V127.541l.641-.641h6.54l.641.641v18.405H97.232V127.541l.641-.641h6.54l.641.641v31.066l-.641.641h-6.54l-.641-.641V146.653H83.622v11.954l-.641.641h-6.54Z",
    transform: "translate(0 -1.48)",
    fill: "#807ce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M353.1,126.9h7.932l6.319,12.064,6.319-12.064h7.888l.641.641-10.915,17.234v13.832l-.685.641h-6.5l-.641-.641V144.775L352.5,127.541Z",
    transform: "translate(-215.562 -1.48)",
    fill: "#807ce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M515.417,159.248H501.541l-.641-.641V127.541l.641-.641h13.876c8.949,0,14.318,6.805,14.318,16.174,0,9.391-5.435,16.174-14.318,16.174Zm-6.695-6.142h3.27c5.435,0,9.9-2.872,9.9-10.031s-4.662-10.031-9.9-10.031h-3.27v20.063Z",
    transform: "translate(-331.173 -1.48)",
    fill: "#807ce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M643.9,141.594c0-9.523,5.435-16.594,15.29-16.594s15.29,7.026,15.29,16.594-5.48,16.549-15.29,16.549S643.9,151.073,643.9,141.594ZM659.212,152c4.463,0,7.468-3.425,7.468-10.407s-2.806-10.451-7.468-10.451-7.468,3.557-7.468,10.451S654.55,152,659.212,152Z",
    transform: "translate(-442.576 0)",
    fill: "#807ce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M819.8,158.607l-12.683-27.133v27.133l-.641.641h-6.5l-.685-.641V127.541l.685-.641h5.48l.685.641L819.1,155.05V127.541l.641-.641h6.54l.641.641v31.066l-.641.641h-5.833l-.641-.641Z",
    transform: "translate(-563.64 -1.48)",
    fill: "#807ce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M235.315,145.946l3.535-9.346h0l3.579,9.346Zm-.265.707-4.507,11.954-.641.641h-6.761l-.641-.641,12.926-31.2.729-.508h5.48l.729.508,12.948,31.2-.641.641H247.91l-.641-.641L242.7,146.653H235.05Z",
    transform: "translate(-114.286 -1.48)",
    fill: "#807ce0",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.090207fcdb5d320004ed3f6e9ee397f2.svg";
export { ForwardRef as ReactComponent };